import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Switch } from '@/components/ui/switch';
import {
  ESTRATEGIAS,
  ESTRATEGIA_EXPLICACAO,
  ESTRATEGIA_LABEL,
  lanceFixoAutomaticoPara,
  mostraFixoAutomatico,
  normalizarEstrategia,
  type EstrategiaContemplacao,
} from './estrategiaContemplacao';

type Props = {
  /** Prefixo dos ids dos campos (o formulário e a aba da venda podem coexistir). */
  idPrefixo: string;
  estrategia: EstrategiaContemplacao | string | null | undefined;
  lanceFixoAutomatico: boolean | null | undefined;
  /** Sempre devolve os dois: escolher sorteio/fixo já define o fixo automático. */
  onChange: (estrategia: EstrategiaContemplacao, lanceFixoAutomatico: boolean) => void;
  disabled?: boolean;
};

/**
 * "Estratégia de contemplação" (migration 237): as quatro opções com uma linha
 * de explicação e, onde ele decide algo (nenhuma e lance livre), o controle do
 * fixo automático. Usado no formulário de venda e na aba "Dados da venda".
 */
export const EstrategiaContemplacaoCampo = ({
  idPrefixo,
  estrategia,
  lanceFixoAutomatico,
  onChange,
  disabled,
}: Props) => {
  const atual = normalizarEstrategia(estrategia);
  const fixoAuto = lanceFixoAutomaticoPara(atual, lanceFixoAutomatico);
  const idSelect = `${idPrefixo}-estrategia`;
  const idFixo = `${idPrefixo}-fixo-auto`;

  return (
    <div className="space-y-2">
      <Label htmlFor={idSelect}>Estratégia de contemplação</Label>
      <Select
        value={atual}
        onValueChange={(v) => {
          const nova = normalizarEstrategia(v);
          onChange(nova, lanceFixoAutomaticoPara(nova, lanceFixoAutomatico));
        }}
        disabled={disabled}
      >
        <SelectTrigger id={idSelect}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {ESTRATEGIAS.map((e) => (
            <SelectItem key={e} value={e}>
              {ESTRATEGIA_LABEL[e]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground">{ESTRATEGIA_EXPLICACAO[atual]}</p>

      {mostraFixoAutomatico(atual) && (
        <div className="flex items-center justify-between gap-3 pt-1">
          <div className="space-y-0.5">
            <Label htmlFor={idFixo} className="text-sm">
              {atual === 'lance_livre' ? 'Fixo automático como garantia' : 'Lance fixo automático'}
            </Label>
            <p className="text-xs text-muted-foreground">
              {atual === 'lance_livre'
                ? 'Sem lance livre registrado até a véspera, o lance fixo é registrado automaticamente.'
                : 'Lance fixo registrado automaticamente na véspera da assembleia, se a cota estiver sem lance.'}
            </p>
          </div>
          <Switch
            id={idFixo}
            checked={fixoAuto}
            onCheckedChange={(v) => onChange(atual, v)}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};
